// Pure mapping from a validated `styling` object (spec.data-model §5) onto the
// `--card-*` contract the card renders with (spec.design-system §4). Kept
// dependency-free so both the creator flow and the data layer can use it without
// an import cycle.
export function stylingToCardVars(styling: Record<string, string> | undefined): string {
  if (!styling) return '';
  const parts: string[] = [];
  const push = (k: string, v?: string) => {
    if (v) parts.push(`${k}:${v}`);
  };
  push('--card-bg', styling.bgGradient);
  push('--card-fg', styling.fontColor);
  push('--card-fg-muted', styling.fontColor);
  push('--card-accent', styling.accent);
  push('--card-contactless', styling.accent);
  push('--card-mono-bg', styling.accent);
  push('--card-font', styling.fontFamily);
  push('--card-name-font', styling.fontFamily);
  push('--card-shadow', styling.glow);
  return parts.length ? parts.join(';') + ';' : '';
}
